import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable,Subscription } from 'rxjs';
import { TimerObservable } from "rxjs/observable/TimerObservable";
import { LoaderService } from '../../../services/loader.service';
import { LeadService } from '../../lead/lead.service';
import { CsagentService } from './csagent.service';
import {
  FormControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { FormsModule } from '@angular/forms';
declare var $:any;

@Component({
  selector: 'app-csagentdashboard',
  templateUrl: './csagentdashboard.component.html',
  styleUrls: ['./csagentdashboard.component.css'],
  providers: [LeadService,CsagentService]
})
export class CsagentdashboardComponent implements OnInit {

  addLeadForm: FormGroup;
  errorMessage : string;
   erroralert = false;
  successalert = false;
  successMessage : string;
  errorMessagemodal : string;
  erroralertmodal = false;
  successalertmodal = false;
  successMessagemodal : string;
  showStatus:boolean;
  agentID : string;
  userAgentDetails : any;
  activeLeadDataForAgent : any;
  leadDetails:any;
  note_records : any;
  city_others;
  leadStatusUpdateForm : FormGroup;
  leadquestionnaire : FormGroup;
  addleadquestionnaire : FormGroup;
  accommodation_type = ['Studio Apartment','1RK','1BHK','1.5BHK','2BHK','2.5BHK','3BHK',
    '3.5BHK','4BHK','4.5BHK','5BHK','Villa','Bungalow','Office Space'];
  scopeOfwork = ['Modular Kitchen','Loose Furniture','Full Home Interiors (Design)','Full Home Interiors (Design & Fullfilment)','Partial Home Interiors (e.g. MKW + Living Room)'];
  callbacktime = ['10:00 AM','10:30 AM','11:00 AM','11:30 AM','12:00 PM','12:30 PM','1:00 PM',
                '1:30 PM','2:00 PM','2:30 PM','3:00 PM','3:30 PM','4:00 PM','4:30 PM','5:00 PM',
                '5:30 PM','6:00 PM','6:30 PM','7:00 PM','7:30 PM','8:00 PM','8:30 PM','9:00 PM','9:30 PM',
                '10:00 PM','10:30 PM','11:00 PM'];
  estimatedPossessionTime = ['Jan-18','Feb-18','Mar-18','Apr-18','May-18',
    'Jun-18','Jul-18','Aug-18','Sep-18','Oct-18','Nov-18','Dec-18'];
  lostReasonsArr=['low_budget','less_scope_of_work','city_not_in_operations','general_inquiry',
    'language_barrier','reluctant_to_provide_details_wrong_number','others'];
  constructor(
    private router: Router,
    private loaderService : LoaderService,
    private leadService : LeadService,
    private formBuilder:FormBuilder,
    private csagentService:CsagentService
  ) {
    this.showStatus = true;
  }

  ngOnInit() {
    this.loaderService.display(false);
    this.agentID = localStorage.getItem('userId');
    this.addLeadForm = this.formBuilder.group({
      name : new FormControl(""),
      email : new FormControl("",[Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
      contact : new FormControl("",[Validators.required]),
      pincode : new FormControl(""),
      lead_type_id : new FormControl("",Validators.required),
      lead_source_id : new FormControl("",Validators.required),
      lead_campaign_id:new FormControl(""),
      lead_status:new FormControl(""),
      follow_up_time: new FormControl(""),
      remark: new FormControl(""),
      lost_reason: new FormControl(""),
      lost_remark : new FormControl(""),
      instagram_handle: new FormControl(""),
      lead_type_name:new FormControl()
    });
    this.leadStatusUpdateForm = this.formBuilder.group({
      lead_status : new FormControl("",Validators.required),
      follow_up_time : new FormControl(""),
      remark: new FormControl(""),
      lost_reason: new FormControl(""),
      lost_remark : new FormControl("")
    });
    this.leadquestionnaire = this.formBuilder.group({
      customer_name : new FormControl(""),
      phone : new FormControl(""),
      society:new FormControl(""),
      project_name: new FormControl(""),
      city : new FormControl(""),
      location: new FormControl(""),
      project_type :new FormControl(""),
      accomodation_type: new FormControl(""),
      home_type: new FormControl(""),
      scope_of_work : new FormControl(""),
      // scope_of_work : new FormArray([]),
      // remarks_of_sow: new FormControl(),
      budget_value: new FormControl(),
      home_value : new FormControl(),
      possession_status :new FormControl(""),
      possession_status_date:new FormControl(""),
      have_homeloan: new FormControl(""),
      call_back_day: new FormControl(""),
      call_back_time: new FormControl(""),
      have_floorplan: new FormControl(""),
      lead_generator: new FormControl(""),
      lead_source:new FormControl(""),
      lead_floorplan:new FormControl(""),
      additional_comments :new FormControl(""),
      ownerable_type : new FormControl('Lead'),
      user_id : new FormControl(localStorage.getItem('userId')),
      ownerable_id : new FormControl()
    });
    this.addleadquestionnaire = this.formBuilder.group({
      customer_name : new FormControl(""),
      phone : new FormControl(""),
      society:new FormControl(""),
      project_name: new FormControl(""),
      city : new FormControl(""),
      pincode: new FormControl(""),
      location: new FormControl(""),
      project_type :new FormControl(""),
      accomodation_type: new FormControl(""),
      home_type: new FormControl(""),
      scope_of_work : new FormControl(""),
      // scope_of_work : new FormArray([]),
      // remarks_of_sow: new FormControl(),
      budget_value: new FormControl(""),
      home_value : new FormControl(""),
      possession_status :new FormControl(""),
      possession_status_date:new FormControl(""),
      have_homeloan: new FormControl(""),
      call_back_day: new FormControl(""),
      call_back_time: new FormControl(""),
      have_floorplan: new FormControl(""),
      lead_generator: new FormControl(""),
      lead_source:new FormControl(""),
      additional_comments :new FormControl(""),
      ownerable_type : new FormControl('Lead'),
      user_id : new FormControl(localStorage.getItem('userId')),
      ownerable_id : new FormControl(),
      lead_status: new FormControl("",Validators.required),
      follow_up_time : new FormControl(""),
      remark: new FormControl(""),
      lost_remark : new FormControl(""),
      lost_reason: new FormControl("")
    });
    this.getLeadCountForAgent();
    this.getLeadPoolList();
    this.changeShowStatus('offline');
    this.getCitiesForQuestionnaire();
    // this.simpleTimer.newTimer('59sec',59);
    // this.subscribeTimer0();
  }

  getLeadCountForAgent() {
    this.loaderService.display(true);
    this.csagentService.getLeadCountForAgent(this.agentID).subscribe(
      res => {
        Object.keys(res).map((key)=>{ res= res[key];});
        this.userAgentDetails = res;
         this.loaderService.display(false);
      },
      err => {
        console.log(err);
         this.loaderService.display(false);
      }
    );
  }
  lead_types;
  lead_sources;
  lead_campaigns;
  leadTypeCustomerId;
  getLeadPoolList(){
     this.loaderService.display(true);
    this.csagentService.getLeadPoolList().subscribe(
      res => {
        this.lead_types = res['lead_types'];
        for(var i=0;i<this.lead_types.length;i++){
          if(this.lead_types[i].name=='customer'){
            this.leadTypeCustomerId =this.lead_types[i].id;
            break;
          }
        }
        this.lead_campaigns=res['lead_campaigns'];
        this.lead_sources = res['lead_sources'];
         this.loaderService.display(false);
      },
      err => {
        console.log(err);
         this.loaderService.display(false);
      }
     );

  }

  showLeadStatusDropdown(val){
    if(val==this.leadTypeCustomerId){
      document.getElementById('addLeadStatusDropdown').classList.add('d-none');
    } else {
      document.getElementById('addLeadStatusDropdown').classList.remove('d-none');
    }
  }

  addLeadDetails;
  addLeadFormSubmit(data) {
    this.loaderService.display(true);
    //$('#addNewLeadModal').modal('hide');
    data['created_by'] = localStorage.getItem('userId');
    if(data.lead_type_id==this.leadTypeCustomerId){
      data['lead_status'] = 'claimed';
    }
    data['by_csagent'] = true;
    if(this.addLeadForm.controls['lead_type_name'].value=='designer'){
      data['lead_cv']=this.basefile;
    }
    var obj = {
      lead:data
    }
    this.leadService.addLead(obj)
        .subscribe(
          res => {
            Object.keys(res).map((key)=>{ res= res[key];});
            this.addLeadDetails =  res;
            this.addLeadForm.reset();
            this.basefile = undefined;
            this.loaderService.display(false);
            this.successalert = true;
            this.successMessage = "Lead created successfully !!";
            if(res['lead_type']=='customer'){
              document.getElementById('addLeadForm').style.display = 'none';
              document.getElementById('addleadquestionnaireForm').style.display= 'block';
            } else {
              document.getElementById('addLeadStatusDropdown').classList.add('d-none');
              document.getElementById('addleadFormdatetime').setAttribute('style','display: none');
              document.getElementById('addleadFormlostremark').setAttribute('style','display: none');
              document.getElementById('addleadFormlostReason').setAttribute('style','display: none');
              if(document.getElementById('addleadFormRemark')){
                document.getElementById('addleadFormRemark').setAttribute('style','display: none');
              }
              $('#addNewLeadModal').modal('hide');
            }
            setTimeout(function() {
                 this.successalert = false;
            }.bind(this), 15000);
          },
          err => {
            this.loaderService.display(false);
            this.erroralert = true;
            this.errorMessage = JSON.parse(err['_body']).message;
            setTimeout(function() {
                 this.erroralert = false;
            }.bind(this), 15000);
          }
        );
  }

  addLeadQuestionnaire(data){
    this.addleadquestionnaire.controls['ownerable_id'].setValue(this.addLeadDetails.id);
    this.addleadquestionnaire.controls['customer_name'].setValue(this.addLeadDetails.name);
    this.addleadquestionnaire.controls['phone'].setValue(this.addLeadDetails.contact);
    if(this.addleadquestionnaire.controls['city'].value == 'Other'){
      this.addleadquestionnaire.controls['city'].setValue(this.city_others);
      data['city']=this.city_others;
    }
    data['customer_name'] = this.addLeadDetails.name;
    data['phone'] = this.addLeadDetails.contact;
    data['ownerable_id'] = this.addLeadDetails.id;
    data['lead_floorplan'] = this.questionnaire_floorplan_basefile;
    data['scope_of_work']=[data['scope_of_work']];
    var obj= {
      lead_status: data.lead_status,
      follow_up_time : data.follow_up_time,
      remark: data.remark,
      lost_reason: data.lost_reason,
      lost_remark : data.lost_remark,
      pincode: this.addleadquestionnaire.controls['pincode'].value
    }
    if( this.addleadquestionnaire.controls['lead_status'].value == 'qualified' && (this.addleadquestionnaire.controls['pincode'].value=='' || this.addleadquestionnaire.controls['pincode'].value==null || this.addleadquestionnaire.controls['pincode'].value== undefined)){
      this.errorMessage='Pincode is mandatory';
      this.erroralert = true;
      setTimeout(function() {
            this.erroralert = false;
          }.bind(this), 10000);
    } else {
      this.loaderService.display(true);
      this.leadService.updateLeadStatus(obj,this.addLeadDetails.id).subscribe(
        res => {
          this.leadService.postRecordNotesQuestionnaire(this.addLeadDetails.id,data).subscribe(
            res => {
              $('#addNewLeadModal').modal('hide');
              this.addleadquestionnaire.reset();
              this.questionnaire_floorplan_basefile = undefined;
              this.floorplan_attachment_file = undefined;
              document.getElementById('addLeadForm').style.display = 'block';
              if(document.getElementById('addleadFormquestremark')){
                document.getElementById('addleadFormquestremark').style.display = 'none';
              }
              if(document.getElementById('addleadQuestLostReason')){
                document.getElementById('addleadQuestLostReason').style.display = 'none';
              }
              if(document.getElementById('addleadQuestFollowuptime')){
                document.getElementById('addleadQuestFollowuptime').style.display = 'none';
              }
              if(document.getElementById('addleadQuestRemark')){
                document.getElementById('addleadQuestRemark').style.display = 'none';
              }
              document.getElementById('addleadquestionnaireForm').style.display= 'none';
              this.city_others  = undefined;
              this.addLeadDetails = undefined;
              this.changeShowStatus('offline');
              this.getLeadCountForAgent();
              this.successalert = true;
              this.successMessage = "Form submitted successfully!";
              this.loaderService.display(false);
              setTimeout(function() {
                  this.successalert = false;
                }.bind(this), 10000);
              //window.location.reload();
            },
            err => {
                this.loaderService.display(false);
              console.log(err);
               this.erroralert = true;
              this.errorMessage = JSON.parse(err['_body']).message;
              setTimeout(function() {
                  this.erroralert = false;
                }.bind(this), 10000);
            }
          );
        },
        err => {
          console.log(err);
          this.loaderService.display(false);
        }
      );
    }
  }

  callbackTimer(status,leadID) {
   this.leadService.refreshLeads(this.agentID,leadID,this.leadDetails).subscribe(
        res => {
          if(res!=null){
            Object.keys(res).map((key)=>{ res= res[key];});
            this.activeLeadDataForAgent = res;
          } else {
            this.agentStatusChange('',true);
          }
        },
        err => {
          console.log(err);
        }
    );
  }

  // timer;
  // timer_subs;
  // timer_secsCount;
  // time = 60;
  intervalId = null;
  ticks =0;
  ticktimer;

  tickerFunc(tick){
    if(tick != 60) {
      this.ticks = tick
    } else {
      this.ticks = 0;
      this.hello.unsubscribe();
      this.loaderService.display(true);
      this.leadService.refreshLeads(this.agentID,'','').subscribe(
              res => {
                if(res!=null){
                  this.activeLeadDataForAgent = res.lead;
                } else {
                  this.agentStatusChange('',true);
                }
                this.loaderService.display(false);
              },
              err => {
                console.log(err);
                this.loaderService.display(false);
              }
            );
      this.startTimer();
    }

  }

  hello;

  startTimer() {
    this.ticks =0;
    this.ticktimer = Observable.timer(2000,1000);
    this.hello= this.ticktimer.subscribe(t => this.tickerFunc(t));
  }

  stopTimer() {
    this.hello.unsubscribe();
     // this.timer_subs.unsubscribe();
      //this.timer_secsCount.unsubscribe();
  }

  changeShowStatus(status){
    this.loaderService.display(true);
    clearTimeout(this.x);
    clearTimeout(this.y);

    if(status == 'online') {
      this.showStatus = true;
      this.agentStatus=2;
    }
    if(status == 'offline') {
      this.agentStatus=1;
      this.showStatus = false;
      this.getLeadCountForAgent();
      if(this.ticks !=0){
        this.hello.unsubscribe();
      }
      if(this.hello != undefined){
        this.hello.unsubscribe();
      }
    }
    this.csagentService.changeStatusToOnline(this.agentID,status).subscribe(
        res => {
          this.loaderService.display(false);
          if(res != null){
            Object.keys(res).map((key)=>{ res= res[key];});
            this.activeLeadDataForAgent = res;
            this.leadDetails = res;
          }
          else {
            this.activeLeadDataForAgent = undefined;
          }
          if(status=='online'){
            this.startTimer2();
          }

        },
        err => {
          this.loaderService.display(false);
          console.log(err);
        }
    );
  }

  numberCheck(e) {
    if(!((e.keyCode > 95 && e.keyCode < 106)
        || (e.keyCode > 47 && e.keyCode < 58)
        || e.keyCode == 8 || e.keyCode == 39 ||
        e.keyCode == 37|| e.keyCode == 38 || e.keyCode == 40 || e.keyCode == 9 || e.keyCode == 17
        || e.keyCode == 91 || e.keyCode == 86 || e.keyCode == 67 )) {
      return false;
    }
  }

  viewLeadDetails(id) {
    this.leadService.viewLeadDetails(id)
      .subscribe(
          lead => {
            this.leadDetails = lead;
            Object.keys(lead).map((key)=>{ this.leadDetails= lead[key];});
            this.leadEmail = this.leadDetails.email;
            this.leadContact =this.leadDetails.contact;
            this.leadName = this.leadDetails.name;
            this.leadPincode = this.leadDetails.pincode
          },
          error => {
            this.erroralert = true;
            this.errorMessage=JSON.parse(error['_body']).message;
          }
     );
  }

  setLeadStatus(value) {
    if(value=='follow_up') {
      document.getElementById('datetime').setAttribute('style','display: block');
      document.getElementById('remarkChange').setAttribute('style','display: block');
      this.leadStatusUpdateForm.controls['follow_up_time'].setValidators([Validators.required]);
      this.leadStatusUpdateForm.controls['follow_up_time'].updateValueAndValidity();

    } else {
      document.getElementById('datetime').setAttribute('style','display: none');
      document.getElementById('remarkChange').setAttribute('style','display: none');
      this.leadStatusUpdateForm.controls['follow_up_time'].clearValidators();
      this.leadStatusUpdateForm.controls['follow_up_time'].updateValueAndValidity();
        }
    if(value == 'lost') {

      document.getElementById('lostreason').setAttribute('style','display: block');
    } else {
      document.getElementById('lostreason').setAttribute('style','display: none');
    }
    if(value=='qualified' && this.activeLeadDataForAgent.lead_type =='customer'){
      this.setFormFieldRequired(this.leadquestionnaire);
    } else {
      this.removeFormFieldRequired(this.leadquestionnaire);
    }
  }

  userQuestionnaireDetails;
  getUserQuestionnaireDetails(leadId,status){
      this.loaderService.display(true);
      this.leadService.getRecordNotesQuestionnaire(leadId).subscribe(
        res=>{
          Object.keys(res).map((key)=>{ res= res[key];});
          this.userQuestionnaireDetails = res;
          if(this.userQuestionnaireDetails!= null && this.userQuestionnaireDetails.length != 0){
            this.setQuestionnaireDetails(this.userQuestionnaireDetails[0]);
          } else {
            this.leadquestionnaire.reset();
            this.leadquestionnaire.controls['customer_name'].setValue("");
            this.leadquestionnaire.controls['phone'].setValue("");
            this.leadquestionnaire.controls['society'].setValue("");
            this.leadquestionnaire.controls['project_name'].setValue("");
            this.leadquestionnaire.controls['home_type'].setValue("");
            this.leadquestionnaire.controls['city'].setValue("");
            this.leadquestionnaire.controls['location'].setValue("");
            this.leadquestionnaire.controls['project_type'].setValue(""),
            this.leadquestionnaire.controls['accomodation_type'].setValue("");
            this.leadquestionnaire.controls['budget_value'].setValue("");
            this.leadquestionnaire.controls['home_value'].setValue("");
            this.leadquestionnaire.controls['possession_status'].setValue("");
            this.leadquestionnaire.controls['possession_status_date'].setValue("");
            this.leadquestionnaire.controls['have_homeloan'].setValue("");
            this.leadquestionnaire.controls['call_back_day'].setValue("");
            this.leadquestionnaire.controls['call_back_time'].setValue("");
            this.leadquestionnaire.controls['have_floorplan'].setValue("");
            this.leadquestionnaire.controls['lead_generator'].setValue("");
            this.leadquestionnaire.controls['lead_source'].setValue("");
            this.leadquestionnaire.controls['have_floorplan'].setValue("");
            this.leadquestionnaire.controls['lead_floorplan'].setValue("");
            this.leadquestionnaire.controls['additional_comments'].setValue("");
            this.leadquestionnaire.controls['ownerable_type'].setValue('Lead');
            this.leadquestionnaire.controls['user_id'].setValue(localStorage.getItem('userId'));
            this.leadquestionnaire.controls['ownerable_id'].setValue("");
            if(document.getElementById('possesiondate')){
              document.getElementById('possesiondate').style.display='none';
            }
            if(document.getElementById('floorplanQuestionnaire1')){
              document.getElementById('floorplanQuestionnaire1').style.display = 'none';
            }
          }
          this.loaderService.display(false);
        },
        err=>{
          this.loaderService.display(false);
          console.log(err);
        }
       );
    }
    setQuestionnaireDetails(note_records){
      if(note_records!=null){
        if(note_records.customer_name!= null){
          this.leadquestionnaire.controls['customer_name'].setValue(note_records.customer_name);
        } else {
          this.leadquestionnaire.controls['customer_name'].setValue("");
        }
        if(note_records.phone!= null){
          this.leadquestionnaire.controls['phone'].setValue(note_records.phone);
        } else {
          this.leadquestionnaire.controls['phone'].setValue("");
        }
          this.leadquestionnaire.controls['project_name'].setValue(note_records.project_name);
          var elem = this.citiesForQuestionnaire.find(function(e) {
              return e.name == (note_records.city.toLowerCase());
          });
          if(elem !=undefined){
            this.leadquestionnaire.controls['city'].setValue(note_records.city.toLowerCase());
          } else if(note_records.city!='' && note_records.city!=null && note_records.city!=undefined){
            this.leadquestionnaire.controls['city'].setValue('Other');
            this.city_others = note_records.city;
            if(document.getElementById('cityOthersInput2')){
              document.getElementById('cityOthersInput2').classList.remove('d-none');
            }
          }
          else {
            this.leadquestionnaire.controls['city'].setValue(note_records.city);
            // this.city_others = note_records.city;
            // document.getElementById('cityOthersInput').classList.remove('d-none');
          }
          this.leadquestionnaire.controls['location'].setValue(note_records.location);
          this.leadquestionnaire.controls['project_type'].setValue(note_records.project_type);
          this.leadquestionnaire.controls['accomodation_type'].setValue(note_records.accomodation_type);
          this.leadquestionnaire.controls['home_type'].setValue(note_records.home_type);
          this.leadquestionnaire.controls['society'].setValue(note_records.society);
          this.leadquestionnaire.controls['lead_source'].setValue(note_records.lead_source);
          // this.leadquestionnaire.controls['remarks_of_sow'].setValue(note_records.remarks_of_sow);
          this.leadquestionnaire.controls['possession_status'].setValue(note_records.possession_status);
          this.leadquestionnaire.controls['possession_status_date'].setValue(note_records.possession_status_date);
          this.leadquestionnaire.controls['home_value'].setValue(note_records.home_value);
          this.leadquestionnaire.controls['budget_value'].setValue(note_records.budget_value);
          this.leadquestionnaire.controls['have_homeloan'].setValue(note_records.have_homeloan);
          this.leadquestionnaire.controls['call_back_day'].setValue(note_records.call_back_day);
          this.leadquestionnaire.controls['call_back_time'].setValue(note_records.call_back_time);
          this.leadquestionnaire.controls['have_floorplan'].setValue(note_records.have_floorplan);
          this.leadquestionnaire.controls['lead_generator'].setValue(note_records.lead_generator);
          this.leadquestionnaire.controls['additional_comments'].setValue(note_records.additional_comments);
          this.leadquestionnaire.controls['have_floorplan'].setValue(note_records.have_floorplan);
          this.leadquestionnaire.controls['lead_floorplan'].setValue(note_records.lead_floorplan);
          
          if(note_records.scope_of_work != null) {
            if(note_records.scope_of_work.length>0){
              this.leadquestionnaire.controls['scope_of_work'].setValue(note_records.scope_of_work[0]);
            }
            // this.leadquestionnaire.controls['scope_of_work']['controls']=[];
            // for(var k=0;k<note_records.scope_of_work.length;k++){
            //   this.leadquestionnaire.controls['scope_of_work']['controls'].push(new FormControl(note_records.scope_of_work[k]));
            // }
            // this.leadquestionnaire.controls['scope_of_work'].setValue(note_records.scope_of_work);
          }

        if(note_records.have_floorplan == 'Yes'){
          document.getElementById('floorplanQuestionnaire').style.display = 'block';
        } if(note_records.have_floorplan == 'No'){
          document.getElementById('floorplanQuestionnaire').style.display = 'none';
        }
        if(note_records.possession_status=='Awaiting Possession'){
          document.getElementById('possesiondate').style.display = 'block';
        }
        if(note_records.possession_status=='Possession Taken'){
          document.getElementById('possesiondate').style.display = 'none';
        }
    }
    }

  setLeadStatus1(value) {
    if(value=='follow_up') {
      document.getElementById('addleadFormdatetime').setAttribute('style','display: block');
      document.getElementById('addleadFormRemark').setAttribute('style','display: block');
    } else {
      document.getElementById('addleadFormdatetime').setAttribute('style','display: none');
      document.getElementById('addleadFormRemark').setAttribute('style','display: none');
    }
    if(value == 'lost') {
      document.getElementById('addleadFormlostReason').setAttribute('style','display: block');
      // document.getElementById('addleadFormlostremark').setAttribute('style','display: block');
    } else {
      // document.getElementById('addleadFormlostremark').setAttribute('style','display: none');
      document.getElementById('addleadFormlostReason').setAttribute('style','display: none');
    }
  }
  setLeadStatus2(value) {
    if(value=='follow_up') {
      document.getElementById('addleadQuestFollowuptime').setAttribute('style','display: block');
      document.getElementById('addleadQuestRemark').setAttribute('style','display: block');
      this.addleadquestionnaire.controls['follow_up_time'].setValidators([Validators.required]);
      this.addleadquestionnaire.controls['follow_up_time'].updateValueAndValidity();
      this.addleadquestionnaire.controls['remark'].setValidators([Validators.required]);
      this.addleadquestionnaire.controls['remark'].updateValueAndValidity();
    } else {
      document.getElementById('addleadQuestFollowuptime').setAttribute('style','display: none');
      this.addleadquestionnaire.controls['follow_up_time'].clearValidators();
      this.addleadquestionnaire.controls['follow_up_time'].updateValueAndValidity();
      this.addleadquestionnaire.controls['remark'].clearValidators();
      this.addleadquestionnaire.controls['remark'].updateValueAndValidity();
    }
    if(value == 'lost') {
      document.getElementById('addleadQuestLostReason').setAttribute('style','display: block');
    } else {
      document.getElementById('addleadQuestLostReason').setAttribute('style','display: none');
    }
    if(value=='qualified'){
      this.setFormFieldRequired(this.addleadquestionnaire);
    } else {
      this.removeFormFieldRequired(this.addleadquestionnaire);
    }
  }

  setFormFieldRequired(formgrp){
    formgrp.controls['society'].setValidators([Validators.required]);
    formgrp.controls['location'].setValidators([Validators.required]);
    formgrp.controls['city'].setValidators([Validators.required]);
    formgrp.controls['project_type'].setValidators([Validators.required]);
    formgrp.controls['call_back_day'].setValidators([Validators.required]);
    // formgrp.controls['call_back_time'].setValidators([Validators.required]);
    formgrp.controls['accomodation_type'].setValidators([Validators.required]);
    formgrp.controls['home_type'].setValidators([Validators.required]);
    formgrp.controls['scope_of_work'].setValidators([Validators.required]);
    formgrp.controls['have_homeloan'].setValidators([Validators.required]);
    formgrp.controls['possession_status'].setValidators([Validators.required]);
    formgrp.controls['home_value'].setValidators([Validators.required]);
    formgrp.controls['budget_value'].setValidators([Validators.required]);
    if(formgrp.controls['possession_status'].value=='Awaiting Possession'){
      formgrp.controls['possession_status_date'].setValidators([Validators.required]);
      formgrp.controls['possession_status_date'].updateValueAndValidity();
    } else {
      formgrp.controls['possession_status_date'].clearValidators();
      formgrp.controls['possession_status_date'].updateValueAndValidity();
    }
    formgrp.controls['society'].updateValueAndValidity();
    formgrp.controls['location'].updateValueAndValidity();
    formgrp.controls['city'].updateValueAndValidity();
    formgrp.controls['project_type'].updateValueAndValidity();
    formgrp.controls['call_back_day'].updateValueAndValidity();
    // formgrp.controls['call_back_time'].updateValueAndValidity();
    formgrp.controls['accomodation_type'].updateValueAndValidity();
    formgrp.controls['home_type'].updateValueAndValidity();
    formgrp.controls['scope_of_work'].updateValueAndValidity();
    formgrp.controls['have_homeloan'].updateValueAndValidity();
    formgrp.controls['possession_status'].updateValueAndValidity();
    formgrp.controls['home_value'].updateValueAndValidity();
    formgrp.controls['budget_value'].updateValueAndValidity();
    var elems=document.getElementsByClassName('hideAsteriskIcon');
    for(var i=0;i<elems.length;i++){
      elems[i].setAttribute('style','display:inline');
    }
  }
  removeFormFieldRequired(formgrp){
    formgrp.controls['society'].clearValidators();
    formgrp.controls['location'].clearValidators();
    formgrp.controls['city'].clearValidators();
    formgrp.controls['project_type'].clearValidators();
    formgrp.controls['call_back_day'].clearValidators();
    // formgrp.controls['call_back_time'].clearValidators();
    formgrp.controls['accomodation_type'].clearValidators();
    formgrp.controls['home_type'].clearValidators();
    formgrp.controls['scope_of_work'].clearValidators();
    formgrp.controls['have_homeloan'].clearValidators();
    formgrp.controls['possession_status'].clearValidators();
    formgrp.controls['possession_status_date'].clearValidators();
    formgrp.controls['home_value'].clearValidators();
    formgrp.controls['budget_value'].clearValidators();

    formgrp.controls['possession_status_date'].updateValueAndValidity();
    formgrp.controls['society'].updateValueAndValidity();
    formgrp.controls['location'].updateValueAndValidity();
    formgrp.controls['city'].updateValueAndValidity();
    formgrp.controls['project_type'].updateValueAndValidity();
    formgrp.controls['call_back_day'].updateValueAndValidity();
    // formgrp.controls['call_back_time'].updateValueAndValidity();
    formgrp.controls['accomodation_type'].updateValueAndValidity();
    formgrp.controls['home_type'].updateValueAndValidity();
    formgrp.controls['scope_of_work'].updateValueAndValidity();
    formgrp.controls['have_homeloan'].updateValueAndValidity();
    formgrp.controls['possession_status'].updateValueAndValidity();
    formgrp.controls['budget_value'].updateValueAndValidity();
    formgrp.controls['home_value'].updateValueAndValidity();
    var elems=document.getElementsByClassName('hideAsteriskIcon')
    for(var i=0;i<elems.length;i++){
      elems[i].setAttribute('style','display:none');
    }
  }

  leadContact;
  leadEmail;
  leadName;
  leadPincode;
  leadInstagramhandle;
  lead_designerCV;
  // city_others;
  updateStatus(leadStatusData,questionnaireFormData,id) {
    if( leadStatusData.lead_status == 'qualified' && (this.leadPincode=='' || this.leadPincode==null)){
      this.errorMessage='Pincode is mandatory';
      this.erroralert = true;
      setTimeout(function() {
            this.erroralert = false;
          }.bind(this), 10000);
    } else {
      if(this.leadStatusUpdateForm.valid){
        if(leadStatusData.lead_status!='qualified' || (leadStatusData.lead_status=='qualified' ))
        {
          document.getElementById('chnagestatusDropDown').classList.remove('inputBorder');
          leadStatusData['email'] = this.leadEmail;
          leadStatusData['contact']= this.leadContact;
          leadStatusData['name']=this.leadName;
          leadStatusData['pincode']=this.leadPincode;
          leadStatusData['instagram_handle']=this.leadInstagramhandle;
          leadStatusData['lead_cv']=this.basefile;
          this.loaderService.display(true);
          this.leadStatusUpdateForm.controls['lead_status'].setValue("");
          this.leadService.updateLeadStatus(leadStatusData,id).subscribe(
              res => {
                  document.getElementById('lostremark').setAttribute('style','display: none');
                  document.getElementById('lostreason').setAttribute('style','display: none');
                  document.getElementById('datetime').setAttribute('style','display: none');
                  document.getElementById('remarkChange').setAttribute('style','display: none');
                  this.leadquestionnaire.controls['ownerable_id'].setValue(id);
                  this.leadquestionnaire.controls['customer_name'].setValue(this.leadName);
                  this.leadquestionnaire.controls['phone'].setValue(this.leadDetails.contact);
                  questionnaireFormData['ownerable_id'] = id;
                  questionnaireFormData['customer_name'] = this.leadName;
                  questionnaireFormData['phone'] = this.leadDetails.contact;
                  questionnaireFormData['lead_floorplan'] = this.questionnaire_floorplan_basefile;
                  questionnaireFormData['scope_of_work']=[questionnaireFormData['scope_of_work']];
                  if(this.leadquestionnaire.controls['city'].value == 'Other'){
                    this.leadquestionnaire.controls['city'].setValue(this.city_others);
                    questionnaireFormData['city']=this.city_others;
                  }
                  $('#leadDetailsModal').modal('hide');
                  this.leadService.postRecordNotesQuestionnaire(id,questionnaireFormData).subscribe(
                      res => {
                        this.leadquestionnaire.reset();
                        this.leadStatusUpdateForm.reset();
                        this.leadStatusUpdateForm.controls['lead_status'].setValue("");
                        this.loaderService.display(false);

                        this.leadEmail = undefined;
                        this.leadContact = undefined;
                        this.leadName = undefined;
                        this.leadPincode = undefined;
                        this.city_others = undefined;
                        this.questionnaire_floorplan_basefile = undefined;
                        this.floorplan_attachment_file = undefined;
                        document.getElementById('addLeadForm').style.display = 'block';
                        document.getElementById('addleadquestionnaireForm').style.display= 'none';
                        this.successalert = true;
                        this.successMessage = "Details Updated successfully !!";
                         setTimeout(function() {
                               this.successalert = false;
                          }.bind(this), 20000);
                        clearTimeout(this.y);
                        document.getElementById('timer1').innerHTML = 1 + ":" + '00';
                        var presentTime = document.getElementById('timer').innerHTML;
                        clearTimeout(this.x);
                        document.getElementById('timer').innerHTML = 20 + ":" + '00';
                        this.agentStatusChange('',false);
                        // this.leadService.refreshLeads(this.agentID,id,this.leadDetails).subscribe(
                        //   res => {
                        //     if(res!=null){
                        //       this.activeLeadDataForAgent = res.lead;
                        //     } else {
                        //       this.activeLeadDataForAgent =undefined;
                        //       this.agentStatusChange();
                        //     }
                        //    clearTimeout(this.y);
                        //    document.getElementById('timer1').innerHTML = 1 + ":" + '00';
                        //    var presentTime = document.getElementById('timer').innerHTML;
                        //     clearTimeout(this.x);
                        //     document.getElementById('timer').innerHTML = 20 + ":" + '00';
                        //     this.startTimer2();
                        //   },
                        //   err => {
                        //     console.log(err);
                        //   }
                        // );
                      },
                      err => {
                         this.erroralert = true;
                         this.loaderService.display(false);
                        this.errorMessage = JSON.parse(err['_body']).message;
                        setTimeout(function() {
                            this.erroralert = false;
                          }.bind(this), 10000);
                      }
                    );
              },
              err => {
                this.loaderService.display(false);
                this.successalert = true;
                document.getElementById('lostremark').setAttribute('style','display: none');
                document.getElementById('datetime').setAttribute('style','display: none');
                document.getElementById('remarkChange').setAttribute('style','display: none');
                  this.successMessage = "Status updated successfully !!";
                  setTimeout(function() {
                       this.successalert = false;
                  }.bind(this), 2000);
                //this.viewLeadDetails(id);
              }
          )
        }
      }
      if(!this.leadStatusUpdateForm.valid){
        document.getElementById('chnagestatusDropDown').classList.add('inputBorder');
      }
    }

  }
  reasonForLostDropdownChange(val){
      if(val=='others'){
        document.getElementById('addleadFormlostremark').setAttribute('style','display:block');
        this.addLeadForm.controls['lost_remark'].setValidators([Validators.required]);
      } else {
        if(document.getElementById('addleadFormlostremark'))
          document.getElementById('addleadFormlostremark').setAttribute('style','display:none');
          this.addLeadForm.controls['lost_remark'].setValue("");
          this.addLeadForm.controls['lost_remark'].validator=null;
      }
      this.addLeadForm.controls['lost_remark'].updateValueAndValidity();
    }
  reasonForLostDropdownChange1(val){
      if(val=='others'){
        document.getElementById('addleadFormquestremark').setAttribute('style','display:block');
        this.addLeadForm.controls['lost_remark'].setValidators([Validators.required]);
      } else {
        if(document.getElementById('addleadFormquestremark'))
          document.getElementById('addleadFormquestremark').setAttribute('style','display:none');
          this.addLeadForm.controls['lost_remark'].setValue("");
          this.addLeadForm.controls['lost_remark'].validator=null;
      }
      this.addLeadForm.controls['lost_remark'].updateValueAndValidity();
    }
  reasonForLostDropdownChange2(val){
      if(val=='others'){
        document.getElementById('lostremark').setAttribute('style','display:block');
        this.addLeadForm.controls['lost_remark'].setValidators([Validators.required]);
      } else {
        if(document.getElementById('lostremark'))
          document.getElementById('lostremark').setAttribute('style','display:none');
          this.addLeadForm.controls['lost_remark'].setValue("");
          this.addLeadForm.controls['lost_remark'].validator=null;
      }
      this.addLeadForm.controls['lost_remark'].updateValueAndValidity();
    }


  possesionStatusSelected(val,formName) {
    if(val == 'Awaiting Possession' && formName=='leadQuestionnaire') {
      document.getElementById('possesiondate').style.display = 'block';
      if(this.leadStatusUpdateForm.controls['lead_status'].value=='qualified'){
        this.leadquestionnaire.controls['possession_status_date'].setValidators([Validators.required]);
        this.leadquestionnaire.controls['possession_status_date'].updateValueAndValidity();
      } else {
        this.leadquestionnaire.controls['possession_status_date'].clearValidators();
        this.leadquestionnaire.controls['possession_status_date'].updateValueAndValidity();
      }
    }
    if(val =='Possession Taken' && formName=='leadQuestionnaire') {
      document.getElementById('possesiondate').style.display = 'none';
      this.leadquestionnaire.controls['possession_status_date'].setValue(undefined);
      this.leadquestionnaire.controls['possession_status_date'].clearValidators();
      this.leadquestionnaire.controls['possession_status_date'].updateValueAndValidity();
    }
    if(val == 'Awaiting Possession' && formName=='addleadQuestionnaire') {
      document.getElementById('possesionadd_date').style.display = 'block';
      if(this.addleadquestionnaire.controls['lead_status'].value=='qualified'){
        this.addleadquestionnaire.controls['possession_status_date'].setValidators([Validators.required]);
        this.addleadquestionnaire.controls['possession_status_date'].updateValueAndValidity();
      } else {
        this.addleadquestionnaire.controls['possession_status_date'].clearValidators();
        this.addleadquestionnaire.controls['possession_status_date'].updateValueAndValidity();
      }
    }
    if(val =='Possession Taken' && formName=='addleadQuestionnaire') {
      document.getElementById('possesionadd_date').style.display = 'none';
      this.addleadquestionnaire.controls['possession_status_date'].setValue(undefined);
      this.addleadquestionnaire.controls['possession_status_date'].clearValidators();
      this.addleadquestionnaire.controls['possession_status_date'].updateValueAndValidity();
    }
  }

  scopeOfWorkSelected(val){
    if(val!='Remarks'){
      this.leadquestionnaire.controls['remarks_of_sow'].setValue(undefined);
      this.addleadquestionnaire.controls['remarks_of_sow'].setValue(undefined);
    }
  }

  onCheckChange(event,htmlElemName) {
    var formArray: FormArray;
    var addLeadFormArray : FormArray;
    if(htmlElemName== 'scope_of_work') {
      formArray = this.leadquestionnaire.get('scope_of_work') as FormArray;
      addLeadFormArray =  this.addleadquestionnaire.get('scope_of_work') as FormArray;
    }
    /* Selected */
    if(event.target.checked){
      // Add a new control in the arrayForm
      formArray.push(new FormControl(event.target.value));
      addLeadFormArray.push(new FormControl(event.target.value));
    }
    /* unselected */
    else{
      // find the unselected element
      let i: number = 0;
      var j:number = 0;

      formArray.controls.forEach((ctrl: FormControl) => {
        if(ctrl.value == event.target.value) {
          // Remove the unselected element from the arrayForm
          formArray.removeAt(i);
          return;
        }

        i++;
      });
      addLeadFormArray.controls.forEach((ctr: FormControl) => {
        if(ctr.value == event.target.value) {
          // Remove the unselected element from the arrayForm
          addLeadFormArray.removeAt(j);
          return;
        }

        j++;
      });
      if(event.target.value =='Remarks'){
        this.leadquestionnaire.controls['remarks_of_sow'].setValue("");
        this.addleadquestionnaire.controls['remarks_of_sow'].setValue("");
      }
    }
  }

  Details(){
      if($(".addClass").hasClass("hideClass"))
      {
        $(".addClass").removeClass("hideClass");
        $(".addClass1").addClass("hideClass");
        $(".upload1").removeClass("actBtn");
        $(".upload0").addClass("actBtn");
      }
     else
      {
        $(".addClass1").addClass("hideClass");
        $(".upload1").removeClass("actBtn");
        $(".upload0").addClass("actBtn");
      }
   }

  closeModal(){

     if($(".addClass").hasClass("hideClass"))
     {
       $(".addClass").removeClass("hideClass");
       $(".addClass1").addClass("hideClass");
       $(".upload1").removeClass("actBtn");
       $(".upload0").addClass("actBtn");
     }
    else
     {
       $(".addClass1").addClass("hideClass");
       $(".upload1").removeClass("actBtn");
       $(".upload0").addClass("actBtn");
     }
     if(confirm('Are you sure you want to close the modal? If you close the modal the lead will be unassigned.')== true) {
       clearTimeout(this.x);
       this.markLeadEscalated(this.leadDetails.id,'modal close before timer completion');
       this.unassignedLead(this.leadDetails.id);
       // this.leadService.refreshLeads(this.agentID,'','').subscribe(
       //   res => {
       //     if(res!=null){
       //       this.activeLeadDataForAgent = res.lead;
       //       document.getElementById('timer').innerHTML = 20 + ":" + '00';
       //       clearTimeout(this.y);
       //       document.getElementById('timer1').innerHTML = 1 + ":" + '00';
       //       this.startTimer2();
       //       this.leadquestionnaire.reset();
       //       this.leadStatusUpdateForm.reset();
       //       this.city_others ="";
       //     } else {
       //     this.erroralert = true;
       //     this.errorMessage = 'No lead available';
       //     this.changeShowStatus('offline');
       //     this.agentStatus =1;
       //     document.getElementById('onlineText').classList.add('notactivestatusText');
       //     document.getElementById('offlineText').classList.remove('notactivestatusText');
       //     document.getElementById('statusSwitch').style.background = 'red';
       //     setTimeout(function() {
       //          this.erroralert = false;
       //     }.bind(this), 10000);
       //   }
       //     this.loaderService.display(false);
       //   },
       //   err => {
       //     console.log(err);
       //     this.loaderService.display(false);
       //   }
       // );
      document.getElementById('timer').innerHTML = 20 + ":" + '00';
      clearTimeout(this.y);
      document.getElementById('timer1').innerHTML = 1 + ":" + '00';
      $('#leadDetailsModal').modal('hide');
      this.leadquestionnaire.reset();
      this.leadStatusUpdateForm.reset();
      this.city_others ="";
      this.agentStatusChange('You are offline.',false);
    }
  }

  fpQuestionnaireSelected(val,elemId){
    if(val == 'yes' && elemId=='floorplanQuestionnaire'){
      document.getElementById('floorplanQuestionnaire').style.display = 'block';
    } else {
      document.getElementById('floorplanQuestionnaire').style.display = 'none';
      this.floorplan_attachment_file = undefined;
      this.questionnaire_floorplan_basefile = undefined;
    }
    if(val == 'yes' && elemId=='floorplanQuestionnaire1'){
      document.getElementById('floorplanQuestionnaire1').style.display = 'block';
    } else if(elemId=='floorplanQuestionnaire1'){
      document.getElementById('floorplanQuestionnaire1').style.display = 'none';
      this.floorplan_attachment_file = undefined;
      this.questionnaire_floorplan_basefile = undefined;
    }
  }

  questionnaire_floorplan_basefile: any;
  floorplan_attachment_file:any;

  onQuestionnaireFloorplanChange(event){
    this.questionnaire_floorplan_basefile = undefined;
    this.floorplan_attachment_file = event.srcElement.files[0];
    var re = /(?:\.([^.]+))?$/;
    var ext = re.exec(this.floorplan_attachment_file.name)[1];
    var fileReader = new FileReader();
    var base64;
    if(ext == 'jpg' || ext == 'jpeg' || ext=='png' || ext=='gif' || ext=='svg') {
      fileReader.onload = (fileLoadedEvent) => {
        base64 = fileLoadedEvent.target;
        this.questionnaire_floorplan_basefile = base64.result;
      };
    } else {
      document.getElementById('extErrorMsg').classList.remove('d-none');
    }
    fileReader.readAsDataURL(this.floorplan_attachment_file);
  }

  agentStatus=1;
  onchange(event){
    if(event.value==1){
      this.agentStatus =1;
      document.getElementById('onlineText').classList.add('notactivestatusText');
      document.getElementById('offlineText').classList.remove('notactivestatusText');
      document.getElementById('statusSwitch').style.background = 'red';
      this.changeShowStatus('offline');
    }
    if(event.value==2){
      this.agentStatus=2;
      document.getElementById('onlineText').classList.remove('notactivestatusText');
      document.getElementById('offlineText').classList.add('notactivestatusText');
      document.getElementById('statusSwitch').style.background = '#2ed2bb';
      this.changeShowStatus('online');
    }
  }

  // /document.getElementById('timer').innerHTML = 20 + ":" + 00;
  x;
  myVar;
  y;
  timervar;
  startTimer1(parentThis?) {
    var presentTime = document.getElementById('timer').innerHTML;

    var timeArray = presentTime.split(/[:]+/);
    var m = <any>timeArray[0];
    var k=<any>timeArray[1] - 1;
    var s;
      s = this.checkSecond(k);

    if(s==59){m=m-1}
    //if(m<0){alert('timer completed')}
     this.myVar = m + ":" + s;
    document.getElementById('timer').innerHTML = this.myVar;
    if(m<=0 && (s==0|| s=='00')){
      $('#leadDetailsModal').modal('hide');
      this.unassignedLead(this.leadDetails.id);
        this.leadService.refreshLeads(this.agentID,'','').subscribe(
          res => {
            if(res!=null){
              this.activeLeadDataForAgent = res.lead;
              document.getElementById('timer').innerHTML = 20 + ":" + '00';
              clearTimeout(this.y);
              document.getElementById('timer1').innerHTML = 1 + ":" + '00';
              this.startTimer2();
            } else {
              this.activeLeadDataForAgent = undefined;
              this.agentStatusChange('',true);
            }
            this.loaderService.display(false);
          },
          err => {
            console.log(err);
            this.loaderService.display(false);
          }
        );
      // this.myStopFunction();

    }
    else{
      this.x=setTimeout(()=>this.startTimer1(this), 1000);
    }

  }


  checkSecond(sec:any) {
    if (sec < 10 && sec >= 0) {sec = "0" + sec}; // add zero in front of numbers < 10
    if (sec < 0) {sec = "59"};
    return sec;
  }


  myStopFunction() {
      var presentTime = document.getElementById('timer').innerHTML;
      clearTimeout(this.x);
      if(<any>presentTime.split(/[:]+/)[0] > 0){
        this.markLeadEscalated(this.leadDetails.id,'modal close before timer completion');
        this.unassignedLead(this.leadDetails.id);
        this.leadService.refreshLeads(this.agentID,'','').subscribe(
          res => {
            if(res!=null){
              this.activeLeadDataForAgent = res.lead;
              document.getElementById('timer').innerHTML = 20 + ":" + '00';
              clearTimeout(this.y);
              document.getElementById('timer1').innerHTML = 1 + ":" + '00';
              this.startTimer2();
              this.leadquestionnaire.reset();
              this.leadStatusUpdateForm.reset();
              // this.leadDetails.reset();
            } else {
            this.agentStatusChange('',true);
          }
            this.loaderService.display(false);
          },
          err => {
            console.log(err);
            this.loaderService.display(false);
          }
        );

      }
      document.getElementById('timer').innerHTML = 20 + ":" + '00';
  }

  resetTimer(){
    this.myStopFunction();
    document.getElementById('timer').innerHTML = 20 + ":" + '00';
    this.startTimer1();
  }


  startTimer2(parentThis?) {
    var presentTime1 = document.getElementById('timer1').innerHTML;
    var timeArray1 = presentTime1.split(/[:]+/);
    var m1 = <any>timeArray1[0];
    if(m1==1){
      m1= m1-1;
    }
    var k1=<any>timeArray1[1] - 1;
    var s1;
      s1 = this.checkSecond1(k1);

    if(s1==0 || s1=='00')
    {
        m1=m1-1
    }
    this.timervar = m1 + ":" + s1;
    document.getElementById('timer1').innerHTML = this.timervar;
    if(m1<0){
      clearTimeout(this.y);
      this.myStopFunction1("");
    } else {
      this.y=setTimeout(()=>this.startTimer2(this), 1000);
    }

  }


  checkSecond1(sec:any) {
    if (sec < 10 && sec >= 0) {sec = "0" + sec}; // add zero in front of numbers < 10
    if (sec < 0) {sec = "59"};
    return sec;
  }

  myStopFunction1(val) {
      this.loaderService.display(true);
      clearTimeout(this.y);
      this.y =undefined;
      if(val!='afterClaim'){
        document.getElementById('timer1').innerHTML = 1 + ":" + '00';
        if(this.activeLeadDataForAgent){
          this.csagentService.unassignedLead(this.activeLeadDataForAgent.id,this.agentID).subscribe(
            res=> {
              this.leadService.refreshLeads(this.agentID,'','').subscribe(
                res => {
                  if(res!=null){
                    this.activeLeadDataForAgent = res.lead;
                  } else {
                    this.agentStatusChange('',true);
                  }
                   document.getElementById('timer1').innerHTML = 1 + ":" + '00';
                  this.startTimer2();
                  this.loaderService.display(false);
                },
                err => {
                  console.log(err);
                  this.loaderService.display(false);
                }
               );
            },
            err => {
              console.log(err);
            }
            );
        }
        else {
          this.loaderService.display(true);
          this.leadService.refreshLeads(this.agentID,'','').subscribe(
            res => {
              if(res!=null){
                this.activeLeadDataForAgent = res.lead;
              } else {
                this.agentStatusChange('',true);
              }

              this.startTimer2();
              this.loaderService.display(false);
            },
            err => {
              console.log(err);
              this.loaderService.display(false);
            }
           );
        }
      }

  }

  stopTimerAfterClaimLead(leadID) {

    this.loaderService.display(true);
    this.myStopFunction1('afterClaim');
    this.csagentService.claimLeads(leadID,this.agentID,this.activeLeadDataForAgent).subscribe(
      res => {
        this.activeLeadDataForAgent = res.lead;
        this.leadDetails = res.lead;
        this.leadContact = res.lead.contact;
        this.leadEmail = res.lead.email;
        this.leadName = res.lead.name;
        this.leadPincode = res.lead.pincode;
        this.leadInstagramhandle = res.lead.instagram_handle;
        this.lead_designerCV=res.lead.lead_cv;
        $('#leadDetailsModal').modal({
                        backdrop: 'static',
                        keyboard: false,
                        show: true
                });
        this.loaderService.display(false);
        // $('#leadDetailsModal').modal('show');
        // $('#leadDetailsModal').modal({'backdrop': 'static', 'keyboard': false})
      },
      err => {
        console.log(err);
        this.loaderService.display(false);
      }
    );

  }


  markLeadEscalated(leadId,reason){
    this.loaderService.display(true);
    this.csagentService.markLeadEscalaetd(leadId,reason).subscribe(
        res=>{
          this.loaderService.display(false);
        },
        err => {
          console.log(err);
          this.loaderService.display(false);
        }
     );
  }
  unassignedLead(leadId){
    this.loaderService.display(true);
    this.csagentService.unassignedLead(leadId,localStorage.getItem('userId')).subscribe(
        res=>{
          this.loaderService.display(false);
        },
        err => {
          console.log(err);
          this.loaderService.display(false);
        }
     );
  }

  callResponse;
  callLead(leadId){
    this.csagentService.callLead(localStorage.getItem('userId'),leadId).subscribe(
      res=>{
        if(res.inhouse_call.call_response.code == '403'){
              this.erroralert = true;
              this.errorMessage = JSON.parse(res.message.body).RestException.Message;
              setTimeout(function() {
                   this.erroralert = false;
              }.bind(this), 10000);
              //JSON.parse(temp1.body).RestException.Message
            } else {
              this.callResponse =  JSON.parse(res.inhouse_call.call_response.body);
              this.successalert = true;
             // this.successMessage = 'Calling from - '+this.callResponse.Call.From;
             this.successMessage = 'Calling to '+res.inhouse_call.call_to
              setTimeout(function() {
                   this.successalert = false;
              }.bind(this), 10000);
            }
      },
      err =>  {
        console.log(err);
      }
    );
  }
  onchangeCity1(city){
    if(city=='Other'){
      document.getElementById('cityOthersInput1').classList.remove('d-none');
    } else{
      document.getElementById('cityOthersInput1').classList.add('d-none');
    }
  }
  onchangeCity2(city){
    if(city=='Other'){
      document.getElementById('cityOthersInput2').classList.remove('d-none');
    } else{
      document.getElementById('cityOthersInput2').classList.add('d-none');
    }
  }
  checkEmail(email) {
    var filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!filter.test(email)) {
        return false;
      }
    return true;
  }

  onChangeOfLeadType(val){
    for(var i=0;i<this.lead_types.length;i++){
      if(val==this.lead_types[i].id){
        this.addLeadForm.controls['lead_type_name'].setValue(this.lead_types[i].name);
      }
    }
  }

  attachment_file: any;
  basefile: any;
  uploadCV(event) {
    this.attachment_file = event.target.files[0] || event.srcElement.files[0];
    var fileReader = new FileReader();
    var base64;
    fileReader.onload = (fileLoadedEvent) => {
      base64 = fileLoadedEvent.target;
      this.basefile = base64.result;
    };
    fileReader.readAsDataURL(this.attachment_file);
  }

  citiesForQuestionnaire;
  getCitiesForQuestionnaire(){
    this.loaderService.display(true);
    this.leadService.getCitiesForQuestionnaire().subscribe(
      res=>{
        this.citiesForQuestionnaire = res.cities;
        this.loaderService.display(false);
      },
      err =>{
        console.log(err);
        this.loaderService.display(false);
      }
    );
  }

  agentStatusChange(msg?,arg?){
    
    if(!arg){
      this.erroralert = false;
      this.errorMessage =msg;
    } else {
      this.erroralert = true;
      this.errorMessage = 'No lead available';
    }
    this.changeShowStatus('offline');
    this.agentStatus =1;
    document.getElementById('onlineText').classList.add('notactivestatusText');
    document.getElementById('offlineText').classList.remove('notactivestatusText');
    document.getElementById('statusSwitch').style.background = 'red';
    setTimeout(function() {
         this.erroralert = false;
    }.bind(this), 10000);
  }
}


// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/organisation/csagentdashboard/csagentdashboard.component.ts